import { EMHandle } from "resource-planner-model";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "redux/AppTypes";
import { useAllEMsSelector } from "./useAllEMs";

export function useEMLeads(
  year: number,
  month: number
): { [emId: string]: EMHandle } {
  const state = useSelector((state: AppState) => state);
  const all = Object.values(useAllEMsSelector(state)).filter((em) =>
    em.isLead(state.applicationConfig.item.projectManagerRoles)
  );
  const [active, setActive] = useState({} as { [emId: string]: EMHandle });

  useEffect(() => {
    const date = new Date(year, month);
    const newActive = all
      .filter((em) => !em.isOffboarded(date))
      .reduce((map, em) => {
        map[em.id] = em;
        return map;
      }, {} as { [emId: string]: EMHandle });
    setActive(newActive);
  }, [year, month, all]);

  return active;
}
